import { CoachingEntity } from './coaching-entity.model';
import { InteractionScoringConfigEntity } from './interaction-scoring-config-entity.model';

export const InteractionScoringEntityType = 'interactionScoring';

export interface InteractionScoringEntity
    extends CoachingEntity<InteractionScoringConfigEntity> {}
